import {
  CollapsibleCard,
  Stack,
  TextField,
  Typography,
} from '@atgfr8/atg-ui-tailwind';
import { Placeholder, SelectInput } from '@components';
import {
  ediConfigurationStore,
  fetchEdiProviders,
  setEdiConfigurationStore,
} from '@store/customers/customerDetails';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { isReadonly } from '@utils/utils';
import { For, Show, createSignal, onMount } from 'solid-js';

import { EdiConfiguration as classes } from './classes';

const EdiConfiguration = () => {
  const [ediProviders, setEdiProviders] = createSignal<string[]>([]);
  const [providersLoaded, setProvidersLoaded] = createSignal(false);

  onMount(async () => {
    const res = await fetchEdiProviders();
    res && res.isSuccess && setEdiProviders(res.value);
    setProvidersLoaded(true);
  });

  return (
    <CollapsibleCard
      loading={ediConfigurationStore.isLoading}
      startTitle="EDI Configuration"
      class="mb-2"
    >
      <Stack spacing={2}>
        <For each={ediConfigurationStore.ediData.ediSettings}>
          {(item, index) => (
            <Stack spacing={1}>
              <Typography variant="body1" class={classes.textFieldSuperText}>
                {item.description}
              </Typography>
              {item.name === 'Provider' ? (
                <Show
                  when={providersLoaded()}
                  fallback={<Placeholder variant="rectangular" height={40} />}
                >
                  <SelectInput
                    label={item.name}
                    menuItems={ediProviders().map((provider) => ({
                      label: provider,
                      value: provider,
                    }))}
                    name={item.name}
                    disabled={isReadonly()}
                    value={item.value ?? ''}
                    required={item.required}
                    onChange={(value) =>
                      setEdiConfigurationStore(
                        'ediData',
                        'ediSettings',
                        index(),
                        'value',
                        value,
                      )
                    }
                    dataTestId={formatDataTestId(
                      `${item.name} Provider`,
                      'selectInput',
                    )}
                  />
                </Show>
              ) : (
                <TextField
                  label={item.name}
                  name={item.name}
                  id="full-text-find"
                  size="sm"
                  value={item.value as string}
                  disabled={isReadonly()}
                  required={item.required}
                  onChange={(e: string) =>
                    setEdiConfigurationStore(
                      'ediData',
                      'ediSettings',
                      index(),
                      'value',
                      e,
                    )
                  }
                  dataTestId={`edi-configuration-${item.name}-textInput-${index()}`}
                />
              )}
            </Stack>
          )}
        </For>
      </Stack>
    </CollapsibleCard>
  );
};

export default EdiConfiguration;
